import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsIssueSecurityRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-issue-security',
	path: '/plugins/servlet/project-config/:projectKey/issuesecurity',
};
